// extracted by mini-css-extract-plugin
export default {"button":"styles_button__cLVM3","disabled":"styles_disabled__GZrd+","secondary":"styles_secondary__4LlWI","tertiary":"styles_tertiary__4BkIS"};